import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { DesktopNavigationTabsType } from './Desktop/DesktopNavigationTabs';
import styles from './Tabs.module.scss';

type NavigationTabsProps = {
  tabs: DesktopNavigationTabsType[];
  size?: 's' | 'm';
  className?: string;
};

export const NavigationTabs = ({ tabs, size = 'm', className }: NavigationTabsProps) => {
  return (
    <div className={classNames(styles['navigation-tabs'], styles['size-' + size], className)} role='tablist'>
      {tabs.map((tab, key) => {
        return tab.disabled ? (
          <div key={key} className={classNames(styles.tab, styles.disabled)}>
            {tab.title}
          </div>
        ) : (
          <NavLink
            to={tab.path}
            key={tab.path}
            className={classNames(styles['nav-link'], tab.className)}
            tabIndex={key}
            target={tab.target}
            end={tab.pathMatchEnd}
            aria-disabled={tab.disabled}
          >
            {({ isActive }) => {
              return (
                <div
                  className={classNames(styles.tab, {
                    [styles.active]: tab.active !== undefined ? tab.active : isActive,
                  })}
                >
                  {tab.title}
                </div>
              );
            }}
          </NavLink>
        );
      })}
    </div>
  );
};
